(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/quickplay-modal/assets/javascripts/quickplay-modal-main.js') >= 0) return;  svs.modules.push('/components/sport/quickplay-modal/assets/javascripts/quickplay-modal-main.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const _React = React,
  useState = _React.useState;
const formatCurrency = svs.utils.format.Currency;
const getDisplayName = svs.utils.products.getDisplayName;
const _svs$utils$products$p = svs.utils.products.productIds,
  BOMBEN = _svs$utils$products$p.BOMBEN,
  MALTIPSET = _svs$utils$products$p.MALTIPSET,
  T8 = _svs$utils$products$p.T8,
  T8EXTRA = _svs$utils$products$p.T8EXTRA,
  T8STRYK = _svs$utils$products$p.T8STRYK,
  EUROPATIPSET = _svs$utils$products$p.EUROPATIPSET,
  STRYKTIPSET = _svs$utils$products$p.STRYKTIPSET,
  CHALLENGE = _svs$utils$products$p.CHALLENGE,
  POWERPLAY = _svs$utils$products$p.POWERPLAY,
  MATCHEN = _svs$utils$products$p.MATCHEN,
  RACING = _svs$utils$products$p.RACING;
const _svs$ui = svs.ui,
  Button = _svs$ui.ReactButton,
  Icon = _svs$ui.ReactIcon;
const getSystemPrice = svs.components.lbUi.getSystemPrice;
const _svs$components$sport = svs.components.sport.quickplayModal.coupons,
  Coupon1x2 = _svs$components$sport.Coupon1x2,
  CouponNumberBoard = _svs$components$sport.CouponNumberBoard,
  CouponScore = _svs$components$sport.CouponScore,
  CouponRacing = _svs$components$sport.CouponRacing;
const NumberSelector = svs.components.lbUi.numberSelector.NumberSelector;
const logger = new svs.core.log.Logger('svs.sport.QuickplayModal');
const getPixHandler = svs.components.sport.pixHandler.getPixHandler;
const renderCoupon = _ref => {
  let branding = _ref.branding,
    drawData = _ref.drawData,
    productId = _ref.productId,
    isPixMix = _ref.isPixMix;
  switch (productId) {
    case T8:
    case T8STRYK:
    case T8EXTRA:
    case POWERPLAY:
    case EUROPATIPSET:
    case STRYKTIPSET:
    case CHALLENGE:
      return React.createElement(Coupon1x2, {
        branding: branding,
        drawData: drawData,
        isPixMix: isPixMix
      });
    case BOMBEN:
    case MATCHEN:
      return React.createElement(CouponScore, {
        branding: branding,
        drawData: drawData,
        isPixMix: isPixMix
      });
    case MALTIPSET:
      return React.createElement(CouponNumberBoard, {
        branding: branding,
        drawData: drawData,
        isPixMix: isPixMix
      });
    case RACING:
      return React.createElement(CouponRacing, {
        isPixMix: isPixMix,
        productId: productId,
        raceData: drawData
      });
    default:
      logger.warn("Unsupported product: ".concat(productId));
      break;
  }
};
const QuickplayModalMain = _ref2 => {
  let branding = _ref2.branding,
    drawData = _ref2.drawData,
    onRefreshPix = _ref2.onRefreshPix,
    isPixMix = _ref2.isPixMix,
    productSizes = _ref2.productSizes;
  const productId = drawData.productId;
  const pixHandler = getPixHandler({
    isPixMix
  });
  const _pixHandler$getProduc = pixHandler.getProduct(productId),
    systemCost = _pixHandler$getProduc.systemCost,
    systemType = _pixHandler$getProduc.systemType;
  const _useState = useState(systemCost),
    _useState2 = _slicedToArray(_useState, 2),
    selectedSystemCost = _useState2[0],
    setSelectedSystemCost = _useState2[1];
  const systemPrice = getSystemPrice(selectedSystemCost, systemType, productId);
  const showPricePicker = (productSizes === null || productSizes === void 0 ? void 0 : productSizes.length) > 0;
  const handleOnClick = () => {
    if (isPixMix) {
      const event = {
        category: 'PIX-mixen',
        action: 'Generate row',
        opt_label: getDisplayName(productId)
      };
      svs.components.analytics.trackEvent(event);
    }
    return onRefreshPix({
      updatedSystemCost: selectedSystemCost,
      shouldGenerateNewPix: true
    });
  };
  return React.createElement("div", {
    className: "quickplay-modal-main elevation-400"
  }, React.createElement("div", {
    className: "padding-2 no-text-selection"
  }, Boolean(showPricePicker) && React.createElement(React.Fragment, null, React.createElement("p", {
    className: "align-center price-picker-header margin-bottom-0"
  }, "V\xE4lj belopp"), React.createElement(NumberSelector, {
    className: "quickplay-modal-number-selector",
    isStepOnly: true,
    maxValue: productSizes[productSizes.length - 1],
    minValue: productSizes[0],
    onValueChange: value => {
      setSelectedSystemCost(productSizes[value]);
      onRefreshPix({
        updatedSystemCost: productSizes[value]
      });
    },
    possibleValues: productSizes,
    size: 600,
    suffix: " kr",
    value: productSizes.indexOf(selectedSystemCost)
  })), Boolean(!showPricePicker) && React.createElement("h2", {
    className: "f-900 f-center notranslate margin-bottom-0"
  }, "".concat(formatCurrency(systemPrice), " kr"))), renderCoupon({
    branding,
    drawData,
    productId,
    isPixMix
  }), React.createElement("div", {
    className: "padding-2"
  }, React.createElement(Button, {
    block: true,
    inverted: productId !== MALTIPSET,
    onClick: handleOnClick,
    size: 300,
    transparent: true
  }, React.createElement(Icon, {
    className: "margin-right-1",
    icon: "refresh-pix",
    size: 300
  }), "Generera ny PIX!")));
};
setGlobal('svs.components.sport.quickplayModal.QuickplayModalMain', QuickplayModalMain);

 })(window);